if(document.querySelector('.menu-search')){
    $page.addEventListener('click', e => {
        if(e.target.classList.contains('menu-search__input')){
            $serchPopup.classList.add('search-popup--active');
        } else {
            $serchPopup.classList.remove('search-popup--active');
        }
    })
}
